// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__iHdBd","footer":"NavbarSimple_footer__PncA6","link":"NavbarSimple_link__5+5Xv","linkIcon":"NavbarSimple_linkIcon__ilg8D"};